import { useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';
import { useCachedApi } from '../hooks/useCachedApi';
import PersonaImage from '../components/molecules/PersonaImage';
import styles from './CommunityPage.module.css';

function CommunityPage() {
  const [activeTab, setActiveTab] = useState('featured');
  const { data: featuredPersonas, loading: featuredLoading } = useCachedApi(
    '/v1/public/templates',
    600000
  );
  const { data: communityPersonas, loading: communityLoading } = useCachedApi(
    '/v1/public/community',
    60000
  );
  const isLoading = featuredLoading || communityLoading;

  const renderPersonaGrid = (personas) => (
    <div className={styles.personaGrid}>
      {personas.map((persona) => (
        <div key={persona.personaId} className={styles.personaCardWrapper}>
          {persona.isOfficial && (
            <div className={styles.officialBadge}>By Ego</div>
          )}
          <Link
            to={`/chat/${persona.personaId}`}
            state={{ persona, isOwner: false, username: persona.username }}
            className={styles.personaCardLink}
          >
            <div className={styles.personaCard}>
              <PersonaImage
                personaId={persona.personaId}
                alt={persona.personaName}
                className={styles.personaCardImage}
                isOwner={false}
                username={persona.username}
              />
              <h3>{persona.personaName}</h3>
              <p className={styles.personaType}>{persona.type}</p>
              <p className={styles.personaArchetype}>{persona.archetype}</p>
              <p className={styles.personaSummary}>{persona.summary}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <h2>The Personaverse</h2>
      </div>
      <p className={styles.pageDescription}>
        Explore a universe of AI personas. Chat with official Featured Personas
        built by our team or discover unique Community Creations from users
        around the world!
      </p>

      <div className={styles.tabNav}>
        <button
          className={`${styles.tabButton} ${activeTab === 'featured' ? styles.active : ''}`}
          onClick={() => setActiveTab('featured')}
        >
          Featured Personas
        </button>
        <button
          className={`${styles.tabButton} ${activeTab === 'community' ? styles.active : ''}`}
          onClick={() => setActiveTab('community')}
        >
          Community Library
        </button>
      </div>

      <div className={styles.tabContent}>
        {isLoading && <p>Loading personas...</p>}
        {!isLoading &&
          activeTab === 'featured' &&
          (featuredPersonas?.length > 0 ? (
            renderPersonaGrid(featuredPersonas)
          ) : (
            <p>New Featured Personas are coming soon. Check back later!</p>
          ))}
        {!isLoading &&
          activeTab === 'community' &&
          (communityPersonas?.length > 0 ? (
            renderPersonaGrid(communityPersonas)
          ) : (
            <p>
              The Community Library is waiting for its first creation. Go to
              your{' '}
              <Link to="/profiles">
                <strong>Public Personas</strong>
              </Link>{' '}
              page, set one to "Public," and be the first to be featured!
            </p>
          ))}
      </div>
    </div>
  );
}

export default withAuthenticationRequired(CommunityPage);
